module.exports = __webpack_public_path__ + "static/media/sistrix.7c44f178.svg";